import React from "react";
import { phoneNumberReadable, localPhoneNumberReadable } from "@src/config";

import { appWhatsAppUrl } from "@src/app-details";

/** ---------- Small Reusable Bits ---------- */

interface WhatsAppLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
    useLocalPhoneNumber?: boolean;
    children?: React.ReactNode;
}

const WhatsAppLink = ({ useLocalPhoneNumber = false, children, ...props }: WhatsAppLinkProps) => (
    <a
        {...props}
        aria-label="Chat us on WhatsApp"
        href={appWhatsAppUrl}
        rel="nofollow noopener noreferrer"
        target="_blank"
    >
        {children || (useLocalPhoneNumber ? localPhoneNumberReadable : phoneNumberReadable)}
    </a>
);

export default WhatsAppLink;
